const runtimeConfig =
  typeof window !== "undefined" && window.__SZENDEX_CONFIG__
    ? window.__SZENDEX_CONFIG__
    : {};

const defaultApiUrl = "/api/";

function normalizeApiUrl(url) {
  const apiUrl = (url || defaultApiUrl).trim();
  return apiUrl.endsWith("/") ? apiUrl : `${apiUrl}/`;
}

export const apiBaseURL = normalizeApiUrl(
  runtimeConfig.API_URL || process.env.VUE_APP_API_URL
);
